<div class="chaneNamePopup">
    <div class="name">
        <p translate>steps.menu.stepName</p>

        <input class="inputName" [formControl]="name" placeholder="{{'steps.menu.namePlaceholder'| translate}}">
    </div>
    <div class="btns">
        <div class="cancel pointer">
            <p (click)="cancel()" translate>btns.cancel</p>
        </div>
        <div class="save pointer" [ngClass]="{'disabled':(name.value?.length??0)<1}">
            <p (click)="save()" translate>btns.save</p>
        </div>
    </div>
</div>